import React, { FC, createContext, useState } from 'react';

export const SearchParamContext = createContext<{
  searchTerm: string;
  setContextSearch: React.Dispatch<React.SetStateAction<string>>;
}>({
  searchTerm: '',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setContextSearch: () => {},
});

const SearchContextProvider: FC<{ children: React.ReactNode }> = ({ children }) => {
  const [searchTerm, setContextSearch] = useState<string>('');

  return (
    <SearchParamContext.Provider value={{ searchTerm, setContextSearch }}>
      {children}
    </SearchParamContext.Provider>
  );
};

export default SearchContextProvider;
